<template>
  <div>
    <base-dash-board></base-dash-board>
  </div>
</template>

<script>
import baseDashBoard from '@/views/base/page/DashBoard.vue'
export default {
  name: 'consoleDashBoard',
  components: {
    baseDashBoard
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
